<app-page-header title="Promotion Group Products" description="Review and manage the products included in a promotion group."></app-page-header>
<div><p class="nav_id">promotions > <u>media-planning</u></p></div>
<div [ngClass]="{ 'hidden': loading, 'visible': !loading }" id="promotion-header">
  <dx-button id="back-button" 
            icon="arrowleft"
            [width]="32" 
            [height]="32"
            (click)="returnToPlanning()">
  </dx-button>
  @if (promoInfo) {
    <p><b>{{promoInfo}}</b></p>
  }
</div>
<div class="groupProductsGrid">
  <app-grid-profile-toolbar
    #profileToolbar
    [gridKey]="'promotion-group-products'"
    (profileLoaded)="onProfileLoaded($event)"
  ></app-grid-profile-toolbar>
  <dx-data-grid #groupProductsGrid
    [dataSource]="productDataSource"
    [showBorders]="true"
    [columnAutoWidth]="true"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [wordWrapEnabled]="true"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [columnFixing]="{enabled: true}"
    [columnResizingMode]="'widget'"
    [columnChooser]="{enabled: true, mode: 'select'}"
    [loadPanel]="{enabled: false}"
    [height]="'100%'"
    (onEditorPreparing)="onEditorPreparing($event)"
  >
  <dxo-state-storing
      [enabled]="true"
      type="custom"
      [customLoad]="loadState"
      [customSave]="saveState"
  ></dxo-state-storing>

  <dxo-editing
      mode="batch"
      refreshMode="reshape"
      [allowUpdating]="true"
  ></dxo-editing>

    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxi-column dataField="product_code" caption="Product Code" [width]="120" fixed="true"></dxi-column>
    <dxi-column dataField="product_name" caption="Product Name" [width]="250" fixed="true"></dxi-column>
    <dxi-column dataField="product_line" caption="Product Line"></dxi-column>
    <dxi-column dataField="sell_price" caption="Price" dataType="number" format="currency" [width]="100"></dxi-column>
    <dxi-column dataField="store_position_name" caption="Store Position"></dxi-column>
    <dxi-column dataField="planning_category_name" caption="Planning Category"></dxi-column>
    <dxi-column dataField="slot_type" caption="Slot Type" [width]="100"></dxi-column>
    <dxi-column dataField="edlp" caption="EDLP" dataType="number" [width]="80"></dxi-column>

    <!-- Dynamic media type columns -->
    @for (column of mediaTypeColumns; track column.id) {
      <dxi-column
        [dataField]="column.dataField"
        [caption]="column.caption"
        [dataType]="column.dataType"
        [calculateCellValue]="column.calculateCellValue"
        [setCellValue]="column.setCellValue">
      </dxi-column>
    }
  </dx-data-grid>

  <dx-load-panel
      #loadPanel
      shadingColor="rgba(0,0,0,0.4)"
      [(visible)]="loading"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [hideOnOutsideClick]="false"
    >
  </dx-load-panel>
</div>
